import SectionItemList from './SectionItemList'
import ImageUploader from './ImageUploader'
import TextareaAutosize from './../../../zzl-vue-component/TextareaAutosize'

export default {
	props: {
		value: {
			type: Object
		},
		coverSize: {
			type: String
		}
	},

	components: {
		SectionItemList,
		ImageUploader,
		TextareaAutosize,
	},

	template: `
		<div class="index-section">
			<TextareaAutosize type="text" v-model="value.title"
				class="index-section-input index-section-input-block index-section-title"
				placeholder="見出し"
			/>
			<ImageUploader v-model="value.cover"
				:size="coverSize"
			/>
			<TextareaAutosize
				v-model="value.description"
				class="index-section-input index-section-input-block index-section-description"
				placeholder="説明..."
			/>
			<SectionItemList
				v-model="value"
			/>
		</div>
	`,
}
